import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import * as PaymentsActions from '../../actions';
import * as PaymentsConstants from '../../constants';
import * as D from '../../deps';
import * as PaymentsSelectors from '../../selectors';
import * as PaymentsUtils from '../../utils';
import TOSAgreement from '../TOSAgreement/TOSAgreement';

import * as OwnConstants from './constants';

import './SwitchPlanConfirmationModal.scss';

export const SwitchPlanConfirmationModal = class extends React.Component {
  static propTypes = {
    intl: PropTypes.object,
    isCanceledSubscriber: PropTypes.bool,
    tierSelected: PropTypes.string,
    discountTypeSelected: PropTypes.string,
    durationTypeSelected: PropTypes.string,
    currentProductDurationType: PropTypes.string,
    price: PropTypes.string,
    currency: PropTypes.string,
    vendorSku: PropTypes.string,
    backingProductID: PropTypes.string,
    paymentProvider: PropTypes.string,
    isUpdatingBillingInfo: PropTypes.bool,
    resubscribe: PropTypes.func,
    switchPlan: PropTypes.func,
    closeModal: PropTypes.func,
    stopSwitchingPlans: PropTypes.func,
    isListenerInWebSwitchPlansModalExperiment: PropTypes.bool,
    logSwitchPlansModalUpdatesExposureEvent: PropTypes.func,
  };

  componentDidMount() {
    this.props.logSwitchPlansModalUpdatesExposureEvent();
  }

  state = {
    agreedToTerms: false,
  };

  onDismissClick = () => {
    this.props.closeModal();
  };

  onSubmitClick = () => {
    if (this.props.isCanceledSubscriber) {
      this.props.resubscribe();
    } else {
      const switchPlanParams = {
        vendorSku: this.props.vendorSku,
        backingProductIdentifier: this.props.backingProductID,
        paymentProvider: this.props.paymentProvider,
        tier: this.props.tierSelected,
        discountType: this.props.discountTypeSelected,
        durationType: this.props.durationTypeSelected,
      };

      this.props.switchPlan(switchPlanParams);
    }

    this.props.closeModal();
    this.props.stopSwitchingPlans();
  };

  onTOSToggle = ({ isChecked }) => {
    this.setState({
      agreedToTerms: isChecked,
    });
  };

  renderTitle = () => {
    return (
      <div className='SwitchPlanConfirmationModal__title'>
        <FormattedMessage {...OwnConstants.messages.reviewYourChange} />
      </div>
    );
  };

  renderSubtitle = () => {
    return (
      <div className='SwitchPlanConfirmationModal__subtitle'>
        <FormattedMessage {...OwnConstants.messages.youAreChangingTo} />
      </div>
    );
  };

  renderOffer = () => {
    const { tierSelected, discountTypeSelected, durationTypeSelected, intl, price, currency } =
      this.props;

    const frequency = PaymentsUtils.getPaymentFrequencyForDurationType(durationTypeSelected);

    return (
      <div className='SwitchPlanConfirmationModal__offer'>
        <div className='SwitchPlanConfirmationModal__offer__planName'>
          {PaymentsUtils.getPlanName(tierSelected, discountTypeSelected)}
        </div>
        <div className='SwitchPlanConfirmationModal__offer__price'>
          <FormattedMessage
            {...OwnConstants.messages.offerPrice}
            values={{
              price: PaymentsUtils.formatPrice(intl, price, currency),
              frequency,
            }}
          />
        </div>
      </div>
    );
  };

  renderPlanBlurb = () => {
    const { tierSelected, discountTypeSelected } = this.props;

    const planBlurb = PaymentsUtils.getPlanBlurb(tierSelected, discountTypeSelected);

    return (
      <div className='SwitchPlanConfirmationModal__planBlurb'>
        <FormattedMessage {...planBlurb} />
      </div>
    );
  };

  renderAutoRenewalDisclaimer = () => {
    const {
      durationTypeSelected,
      price,
      currency,
      intl,
      trialPrice,
      offerTrialType,
      trialTimesRenewable,
      displayableDurationType,
      offerDurationTime,
      offerDurationType,
      trialDurationTime,
      trialDurationType,
      activeProductExpirationDate,
      activeProductNextBillingDate,
      activeProductPrice,
      locale,
      isGiftee,
    } = this.props;
    const displayableTrialDuration = PaymentsUtils.formatDisplayableDuration(
      trialDurationTime,
      trialDurationType,
    );
    const autoRenewalDisclaimerValues = {
      trialPrice,
      displayableBackingPrice: PaymentsUtils.formatPrice(intl, price, currency),
      durationType: durationTypeSelected,
      offerTrialType,
      trialTimesRenewable,
      displayableDurationType,
      displayableTrialDuration,
      offerDurationTime,
      offerDurationType,
      activeProductExpirationDate,
      activeProductNextBillingDate,
      activeProductPrice,
      locale,
      intl,
      isGiftee,
    };
    return (
      <div className='SwitchPlanConfirmationModal__AutoRenewalDisclaimer'>
        {PaymentsUtils.getAutoRenewalDisclaimer(autoRenewalDisclaimerValues)}
      </div>
    );
  };

  renderTOS = () => {
    return (
      <div className='SwitchPlanConfirmationModal__TOS'>
        <TOSAgreement
          tier={this.props.tierSelected}
          discountType={this.props.discountTypeSelected}
          durationType={this.props.durationTypeSelected}
          onChange={this.props.isListenerInWebSwitchPlansModalExperiment ? this.onTOSToggle : null}
        />
      </div>
    );
  };

  renderButtons = () => {
    return (
      <div className='SwitchPlanConfirmationModal__buttonRow'>
        <D.ButtonT3
          className='SwitchPlanConfirmationModal__dismissButton'
          onClick={this.onDismissClick}
          isInline={true}
          theme={D.ButtonT3Theme.LIGHT_TRANSPARENT}
          size={D.ButtonT3Size.LARGE}
        >
          <FormattedMessage {...PaymentsConstants.Messages.dismiss} />
        </D.ButtonT3>
        <D.ButtonT3
          className='SwitchPlanConfirmationModal__ctaButton'
          onClick={this.onSubmitClick}
          isInline={true}
          type={D.ButtonT3Type.SUBMIT}
          size={D.ButtonT3Size.LARGE}
          isDisabled={
            this.props.isListenerInWebSwitchPlansModalExperiment ? !this.state.agreedToTerms : false
          }
        >
          <FormattedMessage {...PaymentsConstants.Messages.submit} />
        </D.ButtonT3>
      </div>
    );
  };

  render() {
    return (
      <div className='SwitchPlanConfirmationModal'>
        <div className='SwitchPlanConfirmationModal__header'>
          {this.renderTitle()}
          {this.renderSubtitle()}
        </div>
        <div className='SwitchPlanConfirmationModal__body'>
          {this.renderOffer()}
          {this.renderPlanBlurb()}
          {this.props.isListenerInWebSwitchPlansModalExperiment &&
            this.renderAutoRenewalDisclaimer()}
        </div>
        <div className='SwitchPlanConfirmationModal__footer'>
          {this.renderTOS()}
          {this.renderButtons()}
        </div>
      </div>
    );
  }
};

export function mapStateToProps(state, ownProps) {
  const { tierSelected, discountTypeSelected, durationTypeSelected } = ownProps;

  const isCanceledSubscriber = PaymentsSelectors.isCurrentListenerCanceledSubscriber(state);
  const currency = PaymentsSelectors.getActiveProductCurrency(state);
  const getBackingProductPrice = PaymentsSelectors.createGetBackingProductPriceSelector(state);
  const price = getBackingProductPrice(tierSelected, discountTypeSelected, durationTypeSelected);
  const paymentProvider = PaymentsSelectors.getSubscriptionPaymentProvider(state);
  const getOfferVendorSku = PaymentsSelectors.createGetOfferVendorSkuSelector(state);
  const vendorSku = getOfferVendorSku(tierSelected, discountTypeSelected, paymentProvider);
  const getOfferBackingProductId = PaymentsSelectors.createGetOfferBackingProductIdSelector(state);
  const backingProductID = getOfferBackingProductId(
    tierSelected,
    discountTypeSelected,
    durationTypeSelected,
  );
  const getTrialPrice = PaymentsSelectors.createGetTrialPriceSelector(state);
  const trialPrice = getTrialPrice(tierSelected, discountTypeSelected);
  const getOfferTrialType = PaymentsSelectors.createGetOfferTrialTypeSelector(state);
  const offerTrialType = getOfferTrialType(tierSelected, discountTypeSelected);
  const trialTimesRenewable = PaymentsSelectors.createGetTrialTimesRenewableSelector(state)(
    tierSelected,
    discountTypeSelected,
  );
  const displayableDurationType =
    PaymentsUtils.getPaymentFrequencyForDurationType(durationTypeSelected);
  const offerDurationTime = PaymentsSelectors.createGetOfferDurationTimeSelector(state)(
    tierSelected,
    discountTypeSelected,
  );
  const offerDurationType = PaymentsSelectors.createGetOfferDurationTypeSelector(state)(
    tierSelected,
    discountTypeSelected,
  );
  const activeProductExpirationDate = PaymentsSelectors.getActiveProductExpirationDate(state);
  const activeProductNextBillingDate = PaymentsSelectors.getNextBillingDate(state);
  const activeProductPrice = PaymentsSelectors.getActiveProductPrice(state);
  const getTrialDurationTime = PaymentsSelectors.createGetTrialDurationTimeSelector(state);
  const getTrialDurationType = PaymentsSelectors.createGetTrialDurationTypeSelector(state);
  const trialDurationTime = getTrialDurationTime(tierSelected, discountTypeSelected);
  const trialDurationType = getTrialDurationType(tierSelected, discountTypeSelected);
  const locale = D.Utils.i18n.getLocale(state);
  const isListenerInWebSwitchPlansModalExperiment =
    D.Utils.Listener.isListenerInWebSwitchPlansModalExperiment(state);
  const isGiftee = PaymentsSelectors.getIsGiftee(state);

  return {
    isCanceledSubscriber,
    tierSelected,
    discountTypeSelected,
    durationTypeSelected,
    currency,
    price,
    vendorSku,
    backingProductID,
    paymentProvider,
    isListenerInWebSwitchPlansModalExperiment,
    trialPrice,
    offerTrialType,
    trialTimesRenewable,
    displayableDurationType,
    offerDurationTime,
    offerDurationType,
    activeProductExpirationDate,
    activeProductNextBillingDate,
    activeProductPrice,
    trialDurationTime,
    trialDurationType,
    locale,
    isGiftee,
  };
}

export default injectIntl(
  connect(mapStateToProps, {
    closeModal: D.Actions.Modal.closeModal,
    stopSwitchingPlans: PaymentsActions.stopSwitchingPlans,
    resubscribe: PaymentsActions.resubscribe,
    switchPlan: PaymentsActions.switchPlan,
    logSwitchPlansModalUpdatesExposureEvent:
      PaymentsActions.logSwitchPlansModalUpdatesExposureEvent,
  })(SwitchPlanConfirmationModal),
);
